function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    width: 13,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3F6F9"
    },
    points: "256,499.47 512,146.167 414.217,12.53 97.784,12.53 0.001,146.167 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1F9F7"
    },
    points: "97.786,12.53 170.663,146.172 0,146.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1F9F7"
    },
    points: "414.217,12.53 341.327,146.172 255.995,12.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1F9F7"
    },
    points: "341.327,146.172 255.995,499.467 170.663,146.172  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9EE7E7"
    },
    points: "414.217,12.53 511.99,146.172 341.327,146.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9EE7E7"
    },
    points: "255.995,12.53 341.327,146.172 170.663,146.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9EE7E7"
    },
    points: "170.663,146.172 255.995,499.467 0,146.172  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond_icon.e49288c89d706a63bab27f97373db3ca.svg";
export { ForwardRef as ReactComponent };